import { PoOperationCompletionModel } from "./po-operation-completion.model";


export class MonthSummaryModel {
    month: number;
    operationsCompletionInfo: PoOperationCompletionModel[];

    constructor(month: number, operationsCompletionInfo: PoOperationCompletionModel[]) {
        this.month = month;
        this.operationsCompletionInfo = operationsCompletionInfo;
    }
}
